import React from 'react';
import { useTranslation, initReactI18next } from "react-i18next";
import { Col, Row, Button } from "reactstrap";
import i18n from '../../../i18n';
import { Trans } from "react-i18next";
import { Page, TransparentPage, SheetOfPaper } from "../../../components/Page/Page";
import Chapter from "../../../components/Chapter/Chapter";
import SourceHeader from "../../../components/SourceHeader/SourceHeader";

import routes from './c05_routes.js';
import ENTranscriptPDF from './Transcripts/en/en_c5_p12.pdf';
import NOTranscriptPDF from './Transcripts/no/no_c5_p12.pdf';
import DocumentIMG from './Media/c5_p12.jpg';

const C05P12 = (props) => {
	const { t } = useTranslation();
	const translation_namespace = 'c05_p12';

	return (
		<Chapter pages={routes} chapterName={props.chapterName} currentPageYear={props.year}>
			<Page className="C05P12">
				<TransparentPage>
					<p><img src={ DocumentIMG } alt={ t('Image of the original document transcribed next') } /></p>
					<ul className="download-links">
						<li><a href={ i18n.language === 'nb-NO' ? NOTranscriptPDF : ENTranscriptPDF } target="_blank"><Trans>Download</Trans> pdf <Trans>file</Trans></a></li>
						<li><a href={DocumentIMG} target="_blank"><Trans>Download</Trans> <Trans>image file</Trans></a></li>
					</ul>
				</TransparentPage>
				<SheetOfPaper>
					<SourceHeader name={ props.name } chapterName={ props.chapterName } />
					<p>
						<strong><Trans ns={ translation_namespace }>Letter from the Central Passport Office to the Royal Norwegian Legation in Berlin October 24th, 1939. Journal no. 1941/254 in the Central Passport Office’s archives. The National Archives in Oslo.</Trans></strong>
					</p>
					<h2><Trans>Transcript</Trans>:</h2>
					<div className="transcript">
						<p>
							<Trans ns={ translation_namespace }>THE CENTRAL PASSPORT OFFICE</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>J.no. 7841-39.</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>R. Norwegian Legation,</Trans><br />
							Berlin.
						</p>
						<p>
							<Trans ns={ translation_namespace }>On referral to the honoured Legation’s letter of October 5th t.y. [= this year] the Central Passport Office permits itself to report that it has agreed to grant Mrs. Lisbeth Grabowski an entry visa to Norway.</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>Oslo, on October 24th, 1939.</Trans>
						</p>
					</div>
				</SheetOfPaper>
			</Page>
		</Chapter>
	);
};

export default C05P12;